// extracted by mini-css-extract-plugin
export var phone = "_1n-0";
export var phoneDragging = "_1n-1";